export default __webpack_public_path__ + "static/media/custom-cookie.0ccff60e.jpg";